import { Link } from "react-router-dom";

export function Logo({ variant = "mark", className = "", to = "/" }) {
  if (variant === "wordmark-light") {
    return (
      <Link to={to} className={`flex items-center gap-2 ${className}`} data-testid="logo-link">
        <span className="font-heading font-extrabold text-xl tracking-tight text-white">
          TDW <span className="text-tech">Nexus AI</span>
        </span>
      </Link>
    );
  }
  return (
    <Link to={to} className={`flex items-center gap-2.5 ${className}`} data-testid="logo-link">
      <img src="/tdw-logo-horizontal.png" alt="Thomason Digital Works" className="h-9 w-auto object-contain" />
      <span className="hidden sm:inline font-heading font-bold text-lg tracking-tight text-navy leading-none">
        Nexus <span className="text-electric">AI</span>
      </span>
    </Link>
  );
}

export function PoweredBy({ className = "" }) {
  return (
    <span className={`text-xs text-metallic font-mono ${className}`}>
      Powered by Thomason Digital Works
    </span>
  );
}
